
import { Component, Prop, Vue } from "vue-property-decorator";
@Component({})
export default class SquareShadowBox extends Vue {
  @Prop({default:true}) displayBox:boolean;
  @Prop({ default: true }) centered: boolean;
  @Prop({ default: "" }) containerClass: string;
}
